<template lang="pug">
  .component-backoffice-parking-slots(v-if="item")
    .action-bar
      .title
        h2 Parking lot Management

    .cards
      .help-text.text-center With OWFF mode, it can happen that vehicle slots are on the same parking slot because one has a started reservation and the other is physically on the parking slot
      .grouped

        .parking-slot.callout(v-for="parkingSlot in slots")
          .placeholder(v-if="parkingSlot.placeholder")
            a.fa.fa-plus.fa-3x(@click="addParkingLot")
          .empty(v-else-if="parkingSlot.vehicle_slots.length === 0")
            strong PS-{{parkingSlot.id}}


            add-vehicle-asset(:item="parkingSlot", @addVehicleAsset="loadSlots")
            .slot
              .button-group.small
                ArchiveVehicleSlots(@slotForArchiveSelected="archiveParkingSlot($event, parkingSlot)")
                button.button.alert.small(@click="deleteParkingSlot(parkingSlot)") Delete Slot

          .parking-slots(v-else, v-for="slot in parkingSlot.vehicle_slots", )
            h3 PS{{parkingSlot.id}}
            Vehicle(:item="slot.vehicle", type="search-result")
              h4 VS{{slot.id}} - {{slot.reservation_type}}
            asset-management-action-buttons(:item="slot", @assetMoved="loadSlots", @vehicleSlotDismissed="loadSlots")

</template>

<script>
  import KeplerBackofficeSdk from '../../../lib/kepler/backoffice'
  import AssetManagementActionButtons from '../../../components/structure/ui/actions/AssetManagementActionButtons'
  import AddVehicleAsset from '../../../components/structure/ui/actions/asset-management/AddVehicleAsset'
  import Vehicle from 'components/backoffice/Vehicle'
  import VehicleSlot from 'components/backoffice/VehicleSlot'
  import Card4 from '../../../components/structure/Card4'
  import Dropdown from '../../structure/foundation/Dropdown'
  import CardN from '../../structure/CardN'
  import MaggieHelper from '../../../maggieHelper'
  import ModalReveal from '../../structure/foundation/ModalReveal'
  import SelectizeGroupedParkingAssets from '../../structure/ui/lists/selectize/SelectizeGroupedParkingAssets'
  import ArchiveVehicleSlots from '../../structure/ui/actions/asset-management/ArchiveVehicleSlots'

  export default {
    name: 'ParkingLotsManage',
    components: {
      ArchiveVehicleSlots,
      SelectizeGroupedParkingAssets,
      ModalReveal,
      CardN,
      Dropdown,
      Card4,
      Vehicle,
      VehicleSlot,
      AddVehicleAsset,
      AssetManagementActionButtons,
    },

    data: function () {
      return {
        item: null,
        slots: []
      }
    },
    created() {
      this.loadSlots()
      this.getParkingLot()
    },
    methods: {

      loadSlots() {
        KeplerBackofficeSdk.parkingSlots.list.slots(this.$route.params.id, (data) => {
          this.slots = data
          this.slots.push({placeholder: true, vehicle_slots: []})
        })
      },
      getParkingLot() {
        KeplerBackofficeSdk.parkingLots.select(this.$route.params.id).get((data) => {
          this.item = data
        })
      },
      deleteParkingSlot(item) {
        this.$confirm('Are you sure?', `Do you really want to delete the parking slot ${item.name} (PS-${item.id})?`, () => {
          KeplerBackofficeSdk.parkingSlots.select(item.id).remove(() => {
            MaggieHelper.notification('Delete', 'Parking slot deleted')
            this.getParkingLot()
            this.loadSlots()
          })
        })
      },
      archiveParkingSlot(destinationSlot, slot) {
        KeplerBackofficeSdk.parkingSlots.select(slot).archive({destination_parking_slot: destinationSlot.id}, () => {
          MaggieHelper.notification('Moved', 'Vehicle slots have been updated')
        })
      },
      addParkingLot() {

        var body = {
          parking_lot_id: this.$route.params.id,
          name: `PL${this.item.id} N° ${this.item.parking_slots.length++}`
        }

        KeplerBackofficeSdk.parkingSlots.make(body, (data) => {
          this.loadSlots()
          this.getParkingLot()
          MaggieHelper.notification('add-esit', 'Parking Lot Created')
        })
      }
    },
    computed: {
      groupedStyle() {
        return {
          flexDirection: 'row',
          paddingRight: '0.5em'
        }
      }
    }
  }
</script>

<style lang="sass">
  .component-backoffice-parking-slots
    .grouped
      display: grid
      grid-template-columns: auto auto auto
      text-align: center

      .parking-slot
        display: flex
        flex-direction: column
        justify-content: center
        border: 1px solid
        margin: 0.5em
        min-height: 300px

        .empty
          display: flex
          flex-direction: column
          align-items: center
          justify-content: center
          height: 50%

          .vehicle
            flex: 1

          .slot
            display: flex
            flex-direction: column
      .placeholder
        cursor: pointer



    .cards
      padding: 2em 3em
</style>



// WEBPACK FOOTER //
// ParkingLotsManage.vue?7f1ca123